export class DrrRequest {
    date: any;
    divisionId?: number;
    clientCode?: string;
    // constructor(date:Date,divisionId?: number,clientCode?: string){
    //     this.date=date;
    //     this.clientCode=clientCode;
    //     this.divisionId=divisionId
    // }
}